// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__10Ds0","footer":"ModalInfo_footer__2Syfa"};